const VISIT_NAMES = {
  0: "Baseline Visit (Visit 1)",
  "-1": "Adverse Event",
  "-2": "Unscheduled Visit",
  "-3": "Screening Visit",
  "-4": "OTHER eCRFS",
  "-6": "eDiary",
};

const getCustomNames = (visitNumber) => {
  if (!visitNumber) return "";

  let customName = VISIT_NAMES[visitNumber.toString()];

  if (!customName) customName = "Visit " + (visitNumber + 1);

  return customName;
};

export default getCustomNames;
